import { takeLatest } from 'redux-saga/effects'

import * as reportsAction from '../actions/reports'
import * as reportsSaga from './reports'

import * as loginAction from '../actions/login'
import * as loginSaga from './login'

import * as userAction from '../actions/user'
import * as userSaga from './user'

import * as managerAction from '../actions/manager'
import * as managerSaga from './manager'

import * as employeeAction from '../actions/employee'
import * as employeeSaga from './employee'

import * as costAction from '../actions/cost'
import * as costSaga from './cost'

import * as accountantAction from '../actions/accountant'
import * as accountantSaga from './accountant'

import * as exchangeRateAction from '../actions/exchangeRate'
import * as exchangeRateSaga from './exchangeRate'


export default function* saga() {
    const relations = [
        [reportsAction, reportsSaga],
        [userAction, userSaga],
        [managerAction, managerSaga],
        [employeeAction, employeeSaga],
        [costAction, costSaga],
        [accountantAction, accountantSaga],
        [loginAction, loginSaga],
        [exchangeRateAction, exchangeRateSaga]
    ];

    for (const [actions, sagas] of relations) {
        for (const [actionName, action] of Object.entries(actions)) {
            const saga = sagas[actionName]

            if (saga)
                yield takeLatest(action.getType(), saga)
        }
    }
    yield takeLatest(loginAction.logoutRequest.getType(),loginSaga.logoutSaga);
    yield takeLatest(loginAction.tokenIsActive.getType(),loginSaga.tokenIsActiveSaga);
}
